import { LoaderContainer, LoaderRing } from "./Loader.styles";

function Loader() {
  return (
    <LoaderContainer>
      <LoaderRing />
    </LoaderContainer>
  );
}

export default Loader;
